// Layout options with Font Awesome icons
export const layoutOptions = [
    { label: 'Compact', value: 'compact', icon: 'fas fa-th' },
    { label: 'Comfortable', value: 'comfortable', icon: 'fas fa-th-large' },
    { label: 'List', value: 'list', icon: 'fas fa-list' }
];

// Standard group by options
export const standardGroupByOptions = [
    { divider: true },
    { label: 'None', value: 'none' },
    { label: 'Sensor Status', value: 'sensorstatus' },
    { label: 'DB Type', value: 'type' },
    { label: 'Host', value: 'host' },
    { label: 'Host Type', value: 'hostType' }
];

// Standard sort by options
export const standardSortByOptions = [
    { divider: true },
    { label: 'Name', value: 'name' },
    { label: 'Sensor Status', value: 'sensorstatus' },
    { label: 'DB Type', value: 'type' },
    { label: 'Total Time', value: 'totalTime' },
    { label: 'Executions', value: 'executions' },
    { label: 'Avg Time', value: 'avgTime' },
    { divider: true },
    { label: 'Host', value: 'host' },
    { label: 'Host Type', value: 'hostType' },
    { label: 'CPU %', value: 'cpu' },
    { label: 'Disk I/O %', value: 'disk' },
    { label: 'Memory %', value: 'mem' }
]; 